import EventLabelAbstractModal, { EventLabelAbstractModalProps } from "../EventLabelAbstractModal";

export type CreateEventCategoryModalProps = EventLabelAbstractModalProps;

export const CreateEventCategoryModal = (props: CreateEventCategoryModalProps) => {
  return <EventLabelAbstractModal {...props}/>;
};

export default CreateEventCategoryModal;
